import { Suspense, lazy } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'sonner'
import { AppShell } from '@/components/layout/AppShell'

const LoginPage              = lazy(() => import('@/pages/auth/LoginPage'))
const DashboardPage          = lazy(() => import('@/pages/dashboard/DashboardPage'))
const OfxImportsListPage     = lazy(() => import('@/pages/ofx-imports/OfxImportsListPage'))
const OfxImportDetailPage    = lazy(() => import('@/pages/ofx-imports/OfxImportDetailPage'))
const BankTransactionsPage   = lazy(() => import('@/pages/bank-transactions/BankTransactionsPage'))
const BankAccountsPage       = lazy(() => import('@/pages/bank-accounts/BankAccountsPage'))
const CategorizationRulesPage = lazy(() => import('@/pages/categorization-rules/CategorizationRulesPage'))

// Settings
const SettingsLayout         = lazy(() => import('@/pages/settings/SettingsLayout'))
const MembersPage            = lazy(() => import('@/pages/settings/MembersPage'))
const CongregadosPage        = lazy(() => import('@/pages/settings/CongregadosPage'))
const OfferingsPage          = lazy(() => import('@/pages/settings/OfferingsPage'))
const AccountCodesPage       = lazy(() => import('@/pages/settings/AccountCodesPage'))
const ExportSettingsPage     = lazy(() => import('@/pages/settings/ExportSettingsPage'))

function PageLoader() {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter basename="/app">
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route element={<AppShell />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />

            {/* OFX Imports */}
            <Route path="/ofx-imports" element={<OfxImportsListPage />} />
            <Route path="/ofx-imports/:uuid" element={<OfxImportDetailPage />} />

            {/* Transactions & Accounts */}
            <Route path="/bank-transactions" element={<BankTransactionsPage />} />
            <Route path="/bank-accounts" element={<BankAccountsPage />} />

            {/* Rules */}
            <Route path="/categorization-rules" element={<CategorizationRulesPage />} />

            {/* Settings */}
            <Route path="/settings" element={<SettingsLayout />}>
              <Route index element={<Navigate to="/settings/members" replace />} />
              <Route path="members" element={<MembersPage />} />
              <Route path="congregados" element={<CongregadosPage />} />
              <Route path="offerings" element={<OfferingsPage />} />
              <Route path="account-codes" element={<AccountCodesPage />} />
              <Route path="export" element={<ExportSettingsPage />} />
            </Route>
          </Route>
        </Routes>
      </Suspense>
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  )
}
